package com.anjuros.website.redesign.sections.contactforms

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdBreadcrumb
import com.anjuros.website.redesign.components.RdGhostButton
import com.anjuros.website.redesign.components.RdLede
import com.anjuros.website.redesign.components.RdPrimaryButton
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.styles.FormsHeroFlowStyle
import com.anjuros.website.redesign.styles.RdButtonRowStyle
import com.anjuros.website.redesign.styles.RdH3Style
import com.anjuros.website.redesign.styles.RdHeroCopyStyle
import com.anjuros.website.redesign.styles.RdHeroStyle
import com.anjuros.website.redesign.styles.RdMarkStyle
import com.anjuros.website.redesign.styles.RdStepsStyle
import com.anjuros.website.redesign.styles.RdSubpageTitleStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private val FlowSteps = listOf(
    RdText.FORMS_FLOW1_TITLE to RdText.FORMS_FLOW1_TEXT,
    RdText.FORMS_FLOW2_TITLE to RdText.FORMS_FLOW2_TEXT,
    RdText.FORMS_FLOW3_TITLE to RdText.FORMS_FLOW3_TEXT,
    RdText.FORMS_FLOW4_TITLE to RdText.FORMS_FLOW4_TEXT,
)

/** Title, intro and the four steps from form to reply. */
@Composable
fun ContactFormsHeroSection() {
    val flowLabel = LocalText(RdText.FORMS_FLOW_LABEL)
    RdSection(labelledBy = "h1", modifier = RdHeroStyle.toModifier()) {
        Div(RdHeroCopyStyle.toModifier().toAttrs()) {
            RdBreadcrumb(RdText.FORMS_CRUMB)
            H1(RdSubpageTitleStyle.toModifier().id("h1").toAttrs()) {
                Text(LocalText(RdText.FORMS_HERO_TITLE_START))
                Span(RdMarkStyle.toModifier().toAttrs()) { Text(LocalText(RdText.FORMS_HERO_TITLE_MARK)) }
            }
            RdLede(RdText.FORMS_HERO_LEDE)
            Div(RdButtonRowStyle.toModifier().toAttrs()) {
                RdPrimaryButton("#demo", RdText.FORMS_HERO_DEMO, withArrow = true)
                RdGhostButton(RdRoute.CONTACT, RdText.NAV_GET_STARTED)
            }
            Ol(RdStepsStyle.toModifier().then(FormsHeroFlowStyle.toModifier()).attrsModifier { attr("aria-label", flowLabel) }.toAttrs()) {
                FlowSteps.forEach { (title, text) ->
                    Li {
                        H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(title)) }
                        P { Text(LocalText(text)) }
                    }
                }
            }
        }
    }
}
